import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const WithPermission = ({
  children,
  isSuperuser,
  hasAnyRole,
  requiredPermission,
  currentPermission,
  redirectTo = "/home"
}) => {
  const location = useLocation();
  const hasPermission = isSuperuser || (hasAnyRole && currentPermission);
  
  if (!hasPermission) {
    return (
      <Navigate 
        to={redirectTo} 
        replace 
        state={{ 
          permissionDenied: true,
          from: location.pathname,
          requiredPermission
        }}
      />
    );
  }
  
  return <>{children}</>;
};

export default WithPermission;